export default __webpack_public_path__ + "static/media/ic_logout.dab33eaa.svg";